import React from "react";
import DatepickerRangeAirbnb from "./DatepickerRangeAirbnb";

// Wrapper component to use the Airbnb-style date picker
const DatepickerRange = ({placeholder="YYYY-MM-DD - YYYY-MM-DD", onChange, startDate, endDate}) => {
    return (
        <DatepickerRangeAirbnb
            placeholder={placeholder}
            onChange={onChange}
            startDate={startDate}
            endDate={endDate}
        />
    );
}

export default DatepickerRange;